import * as React from "react";
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger,
	ListItem,
} from "@/components/ui/navigation-menu";
import cn from "@/lib/cn";
import { useAuth } from "@/providers/auth-provider";
import { useModal } from "@/providers/modal-provider";
import { ArrowRightIcon } from "lucide-react";
import { PRODUCT_FORM } from "@/lib/constants";
import { ModalType } from "@/types/modal-type";

const SubmitProductMenu: React.FC = () => {
	const { isLoggedIn } = useAuth();
	const { openModal } = useModal();
	const [isOpen, setIsOpen] = React.useState(false);

	const handleMouseEnter = () => {
		setIsOpen(true);
	};

	const handleMouseLeave = () => {
		setIsOpen(false);
	};

	const handleButtonClick = (event: React.MouseEvent) => {
		event.preventDefault();
		if (!isLoggedIn) {
			openModal(ModalType.Auth);
		} else {
			window.open("/products/form/getting-started", "_blank");
		}
	};

	return (
		<NavigationMenu onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<NavigationMenuList>
				<NavigationMenuItem>
					<NavigationMenuTrigger
						onClick={handleButtonClick}
						className={cn(
							"flex w-full items-center justify-center gap-1 rounded bg-[#FFA804] py-2 text-sm font-semibold transition hover:bg-[#de9102] active:bg-[#de9102] lg:w-[220px]",
							{ "cursor-pointer": !isLoggedIn }
						)}
						showChevron={false}
					>
						<span>Submit Your Product</span>
						<ArrowRightIcon className="ml-1 h-4 w-4 text-inherit" />
					</NavigationMenuTrigger>
					{isOpen && (
						<NavigationMenuContent>
							<ul className="grid list-none gap-1 bg-white p-4">
								<ListItem title="Submit your product" href={PRODUCT_FORM} />
								<ListItem title="Submit press release" href="/news/press-release" />
								<ListItem title="Book a call?" href="https://cal.com/rohit-sujan/discovery-call" />
								<ListItem title="Contact Us" href="https://www.proptechbuzz.com/contact-us" />
							</ul>
						</NavigationMenuContent>
					)}
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>
	);
};

export default SubmitProductMenu;
